import { PRIMARY_NAVIGATION_BAR_BASE_ROW_HEIGHT } from "@-/dev.improve.haniverse.lib.primary-navigation-strip.entities";
import { Platform } from "@-/com.npmjs.react-native";

/** Icon row height before bottom safe-area / home-indicator clearance. */
export function getPrimaryNavigationBarRowHeight(): number {
  return Platform.OS === "ios"
    ? PRIMARY_NAVIGATION_BAR_BASE_ROW_HEIGHT
    : PRIMARY_NAVIGATION_BAR_BASE_ROW_HEIGHT + 4 + 10;
}

export type PrimaryNavigationBarBottomClearanceOptions = {
  /**
   * When false (gesture navigation / swipe handle only), use half the bottom inset.
   * When true (3-button nav bar), use the full inset and bottom padding in the tab bar.
   */
  androidUsesButtonNavBar?: boolean;
};

const ANDROID_BUTTON_NAV_MIN_SCREEN_WINDOW_GAP_PX = 72;
const ANDROID_BUTTON_NAV_MIN_BOTTOM_INSET_PX = 40;
const IOS_MIN_BOTTOM_CLEARANCE_PX = 4;

export type AndroidUsesButtonNavBarOptions = {
  insetsBottom: number;
  screenHeight: number;
  windowHeight: number;
};

export function getAndroidUsesButtonNavBar({
  insetsBottom,
  screenHeight,
  windowHeight,
}: AndroidUsesButtonNavBarOptions): boolean {
  if (Platform.OS !== "android") {
    return false;
  }

  return (
    screenHeight - windowHeight > ANDROID_BUTTON_NAV_MIN_SCREEN_WINDOW_GAP_PX ||
    insetsBottom >= ANDROID_BUTTON_NAV_MIN_BOTTOM_INSET_PX
  );
}

export function getPrimaryNavigationBarBottomClearance(
  insetsBottom: number,
  options?: PrimaryNavigationBarBottomClearanceOptions,
): number {
  if (Platform.OS === "ios") {
    // The icon row already has its own bottom gutter. Keep a compact home-indicator
    // allowance here; Android's opaque button navigation still needs the full inset.
    return Math.max(insetsBottom / 2, IOS_MIN_BOTTOM_CLEARANCE_PX);
  }
  if (options?.androidUsesButtonNavBar === false) {
    return insetsBottom / 2;
  }
  return insetsBottom;
}

/** Bottom padding applied inside the tab bar on Android (0 for gesture navigation). */
export function getAndroidPrimaryNavigationBarBottomPadding(
  bottomClearance: number,
  androidUsesButtonNavBar: boolean,
): number {
  return androidUsesButtonNavBar ? bottomClearance : 0;
}

export function getPrimaryNavigationBarHeight(
  insetsBottom: number,
  options?: PrimaryNavigationBarBottomClearanceOptions,
): number {
  return (
    getPrimaryNavigationBarRowHeight() +
    getPrimaryNavigationBarBottomClearance(insetsBottom, options)
  );
}
